import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import BsfLearn from '../../lib/bsf-learn';
import { Button } from '@bsf/force-ui';
import { Video } from 'lucide-react';
import UpgradeNotice from "@components/UpgradeNotice";
import NavMenu from '@components/NavMenu';

const Learn = () => {
    const [showVideo, setShowVideo] = useState(false);

    const handleToggleVideo = () => {
        setShowVideo(prevState => !prevState);
    };

    return (
        <>
            <UpgradeNotice />
            <NavMenu />
            <div className="bg-gray-50 min-h-[calc(100vh_-_8rem)]">
                <h1 className="sr-only">{__('Learn', 'header-footer-elementor')}</h1>

                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
                    <div className="max-w-3xl mx-auto px-4">

                        {/* Learn Component Container */}
                        <div className="p-4 bg-background-primary rounded-xl flex flex-col gap-3 flex flex-col gap-4 sm:gap-8">

                            {/* Header Section */}
                            <div className="px-1 flex justify-between relative flex-col items-start space-y-2">
                                <h2 className="m-0 p-0 font-semibold text-base text-text-primary">
                                    {__('Learn', 'header-footer-elementor')}
                                </h2>
                                <p className="m-0 p-0 text-sm text-text-primary">
                                    {__('Master UAE with our step-by-step guide and tutorials. Create stunning headers and footers with confidence.', 'header-footer-elementor')}
                                </p>

                                <Button
                                    className="absolute right-0 whitespace-nowrap"
                                    variant="ghost"
                                    size="xs"
                                    icon={<Video className="w-4 h-4" />}
                                    onClick={handleToggleVideo}
                                >
                                    <span className="sm:inline-block">
                                        {showVideo ? __('Hide Video', 'header-footer-elementor') : __('Watch Video', 'header-footer-elementor')}
                                    </span>
                                </Button>
                            </div>

                            {/* Video Section */}
                            <div className={`transition-all duration-700 ease-in-out overflow-hidden px-6 ${showVideo ? 'max-h-[800px] opacity-100 pb-6' : 'max-h-0 opacity-0 pb-0'
                                }`}>
                                {showVideo && (
                                    <div className="relative rounded-lg shadow-lg aspect-video overflow-hidden">
                                        <iframe
                                            className="w-full h-full"
                                            src="https://www.youtube-nocookie.com/embed/ZeogOxqdKJI?autoplay=1&enablejsapi=1&start=29&end=72"
                                            title="UAE Tutorial Video"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                )}
                            </div>

                            {/* Learn Chapters */}
                            <BsfLearn
                                className="bg-background-secondary p-2 rounded-lg [&>div]:space-y-2"
                                endpoints={{
                                    get: '/hfe/v1/get-learn-chapters',
                                    set: '/hfe/v1/update-learn-progress'
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Learn;